import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Branch } from '@models/branch.model';

@Component({
  selector: 'app-branch-select-form',
  templateUrl: './branch-select-form.component.html',
  styleUrls: ['./branch-select-form.component.scss'],
})
export class BranchSelectFormComponent {
  @Input() branches: Branch[] = [];
  @Input() branchSelected: Branch | null = null;
  @Input() qrGenerated: boolean = false;
  @Output() branchSelectedChange = new EventEmitter<Branch | null>();
  @Output() generate = new EventEmitter<Branch>();

  onSelectionChange(value: Branch) {
    this.branchSelected = value;
    this.branchSelectedChange.emit(value);
  }

  onSubmit() {
    if (this.branchSelected) {
      this.generate.emit(this.branchSelected);
    }
  }
}
